import type { FC } from "react";
import { useBloc as useBlocNext } from "@blac/react";
import { useEffect, useRef } from "react";
import { useSearchParams, useParams, useNavigate } from "react-router-dom";
import BlockingLoadingOverlayController from "../BlockingLoadingOverlay/BlockingLoadingOverlayController";
import AuthenticationBloc from "src/state/UserCubit/AuthenticationBloc";
import HandoverTokenCubit from "src/state/HandoverTokenCubit/HandoverTokenCubit";

const HandoverTokenHandler: FC = () => {
  const [authState] = useBlocNext(AuthenticationBloc);
  const [handoverState, handoverCubit] = useBlocNext(HandoverTokenCubit);
  const [searchParams] = useSearchParams();
  const { partner } = useParams<{ partner: string }>();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  const isAuthenticated = !!authState.credentials.accessToken;

  useEffect(() => {
    const [endLoading] = BlockingLoadingOverlayController.startLoading({
      bg: "branded"
    });

    const processToken = async () => {
      if (
        !isAuthenticated ||
        !partner ||
        hasProcessed.current ||
        handoverState.isProcessing
      ) {
        endLoading();
        return;
      }

      hasProcessed.current = true;

      const config = await handoverCubit.processHandoverToken(
        searchParams,
        partner
      );

      if (config.redirect) {
        if (config.isAppLink) {
          navigate(config.targetUrl.pathname, { replace: true });
        } else {
          window.location.replace(config.targetUrl.toString());
        }
      }
      endLoading();
    };

    void processToken();
  }, [
    isAuthenticated,
    partner,
    searchParams,
    navigate,
    handoverCubit,
    handoverState.isProcessing
  ]);

  return null;
};

export default HandoverTokenHandler;
